import React, { useRef } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  formatDate,
  formatDateNew,
  formatDateWithTime,
} from "../../../constants/DateUtil/DateUtil";
import { getStoreLocalData } from "../../../utils/localStorage";

const B2BOrderInfoCard = ({
  customerOrdersData,
  storeCustomerId,
  bookingOrderId,
  userRole,
  storeInfo,
  brandInfo,
}) => {
  const navigate = useNavigate();
  const orderDetails = customerOrdersData;

  const [show, setShow] = useState(false);

  const { storeLocalData } = getStoreLocalData();

  const op = useRef(null);

  const handleShowHide = () => {
    setShow(!show);
  };

  const orderInfoDetails = {
    challanNo: orderDetails?.challanNo ? orderDetails?.challanNo : "N/A",
    grandTotal: orderDetails?.grandTotal ? orderDetails?.grandTotal : 0,
    paidAmount: orderDetails?.paidAmount ? orderDetails?.paidAmount : 0,
    gstAmount: orderDetails?.gstAmount ? orderDetails?.gstAmount : 0,
    balanceAmount: orderDetails?.balanceAmount
      ? orderDetails?.balanceAmount
      : 0,
    deliveryOn: orderDetails?.deliveryOn ? orderDetails?.deliveryOn : "N/A",
    deliveredOn: orderDetails?.deliveredOn ? orderDetails?.deliveredOn : "N/A",
    status: orderDetails?.status ? orderDetails?.status : "N/A",
    itemGarmentCount: orderDetails?.itemGarmentCount,
    createdDate: orderDetails?.createdDate
      ? orderDetails?.createdDate
      : "2023-11-17T12:26:36Z",
    customerName: orderDetails.customerName,
    mobileNumber: orderDetails.customerMobile
  };

  const displayDeliveryDateText =
    orderInfoDetails.status === "DELIVERED" ||
      orderInfoDetails.status === "DONE"
      ? "Delivered On"
      : "Delivery Date";
  const displayDate =
    orderInfoDetails.status === "DELIVERED" ||
      orderInfoDetails.status === "DONE"
      ? formatDateWithTime(orderInfoDetails.deliveredOn)
      : formatDateNew(orderInfoDetails.deliveryOn);

  const formattedCreatedDate = formatDateWithTime(orderInfoDetails.createdDate);
  // const formattedDeliveredOnDate = formatDate(displayDate);
  const formattedDeliveredOnDate = displayDate;
  // const formattedLastModificationOnDate = formatDate(
  //   orderInfoDetails.lastModifiedDate,
  // );

  const shareMessage = (item) => {
    const challanNo = item.challanNo;
    const customerName = item.customerName;
    const mobile = item.mobileNumber;

    if (!mobile) {
      alert("Mobile number is invalid");
      return;
    }

    // Build garment lines
    const garmentDetails = orderDetails.orderItem
      .map((addOns) => {
        const garment =
          addOns.garmentAlias && addOns.garmentAlias !== ""
            ? addOns.garmentAlias
            : addOns.garmentName;

        return `${garment.replace(/_/g, " ")} - ${addOns.garmentService} - ${addOns.itemGarmentCount}`;
      })
      .join("\n");

    const totalGarments = orderDetails.itemGarmentCount

    const body = `Dear ${customerName}
Your Challan No. ${challanNo}

Garments details :

${garmentDetails}

Thanks for your visit to ${storeInfo.storeName}.
Total garments : ${totalGarments}

Thanks
${brandInfo.name}
${brandInfo.mobileNo}`
;

    const url = `https://api.whatsapp.com/send?phone=91${mobile}&text=${encodeURIComponent(
      body
    )}`;

    window.open(url, "_blank");
  };


  return (
    <div className="flex-1 ">
      <div className="m-4 shadow-4">
        <div className="flex flex-1">
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}
          >
            <p
              className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}
            >
              Challan No. :
            </p>
            <p className="text-xl font-medium capitalize">
              {orderInfoDetails.challanNo}
            </p>
          </div>
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}
          >
            <div className="flex flex-row justify-content-between">
              <div>
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Amt Info :
                </p>
                <p className="text-xl font-medium capitalize">
                  {storeLocalData?.currencySymbol} {orderInfoDetails.grandTotal}
                </p>
              </div>
              <div>
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  {storeLocalData?.taxType} Info :
                </p>
                <p className="text-xl font-medium capitalize">
                  {storeLocalData?.currencySymbol} {orderInfoDetails.gstAmount}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-1">
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}
          >
            <div className="flex justify-content-between">
              <div>
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Paid Info :
                </p>
                <p className="text-xl font-medium capitalize">
                  {storeLocalData?.currencySymbol} {orderInfoDetails.paidAmount}
                </p>
              </div>
            </div>
          </div>
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}
          >
            <div className="flex flex-row justify-content-between">
              <div>
                <p
                  className="text-md font-normal capitalize"
                  style={{ color: "#75879B" }}
                >
                  Balance Amt :
                </p>
                <p className="text-xl font-medium capitalize">
                  {storeLocalData?.currencySymbol} {orderInfoDetails.balanceAmount}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-1">
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#E2F4F8",
            }}
          >
            <p
              className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}
            >
              Booking Date :
            </p>
            <p className="text-xl font-medium capitalize">
              {formattedCreatedDate}
            </p>
          </div>
          <div
            className="flex-1 px-3 py-1"
            style={{
              backgroundColor: "#F8FFEE",
            }}
          >
            <p
              className="text-md font-normal capitalize"
              style={{ color: "#75879B" }}
            >
              {displayDeliveryDateText} :
            </p>
            <p className="text-xl font-medium capitalize">
              {formattedDeliveredOnDate}
            </p>
          </div>
        </div>

        {(userRole === "BY_STORE" || userRole === "BY_RIDER") && (
          <div className="flex flex-1">
            <div
              className="flex-1 px-3 py-1 flex-row justify-content-between"
              style={{
                backgroundColor: "#F8FFEE",
              }}
            >
              <p
                className="text-2xl font-medium capitalize"
                style={{ color: "red" }}
              >
                Order Challan{" "}
              </p>

              <div
                className=" cursor-pointer"
                onClick={() => shareMessage(orderInfoDetails)}
              >
                <img
                  src={"images/WhatsApplogo.png"}
                  style={{
                    width: 34,
                    height: 34,
                  }}
                />
              </div>
              <div
                className="cursor-pointer"
                onClick={() => {
                  navigate("/RiderChallanComponent", {
                    state: {
                      storeCustomerId: storeCustomerId,
                      bookingOrderId: bookingOrderId,
                      customerOrdersData: customerOrdersData,
                      B2BModel: "B2BModel"
                    },
                  });
                }}
              >
                <img
                  src={"Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png"}
                  style={{
                    width: 34,
                    height: 34,
                  }}
                />
              </div>
            </div>

            <div
              className="flex-1 px-3 py-1"
              style={{
                backgroundColor: "#E2F4F8",
              }}
            >
              <p
                className="text-md font-normal capitalize"
                style={{ color: "#75879B" }}
              >
                Total Garments :
              </p>
              <p className="text-xl font-medium capitalize">
                {orderInfoDetails.itemGarmentCount}
              </p>
            </div>
          </div>
        )}
        {orderInfoDetails.editBy && (
          <div className="flex flex-1">
            <div
              className="flex-1 px-3 py-1"
              style={{
                backgroundColor: "#F8FFEE",
              }}
            >
              <p
                className="text-md font-normal capitalize"
                style={{ color: "#75879B" }}
              >
                Edited By :
              </p>
              <p className="text-xl font-medium capitalize">
                {orderInfoDetails.editBy}
              </p>
            </div>
            <div
              className="flex-1 px-3 py-1"
              style={{
                backgroundColor: "#F8FFEE",
              }}
            >
              <p
                className="text-md font-normal capitalize"
                style={{ color: "#75879B" }}
              >
                Last Modification Date :
              </p>
              <p className="text-xl font-medium capitalize">
                {formattedDeliveredOnDate}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default B2BOrderInfoCard;
